import type { CourseModule } from "@/core/types";
import { lektionErsteFormel } from "./lektion-01-erste-formel";
import { lektionBezuege } from "./lektion-02-bezuege";
import { lektionBlattuebergreifend } from "./lektion-03-blattuebergreifend";

export const modulFormeln: CourseModule = {
  id: "formeln",
  title: "Formeln und Bezüge",
  summary:
    "Der zweite rote Faden: Excel rechnet, du tippst nicht. Relative, absolute und " +
    "blattübergreifende Bezüge – und warum keine Zahl in eine Formel gehört.",
  level: "Grundlagen",
  lessons: [lektionErsteFormel, lektionBezuege, lektionBlattuebergreifend],
};
